import styles from './textboxfieldwrapper.module.css';
import parse from 'html-react-parser';
import {
    FieldWrapper,
} from "@progress/kendo-react-form";
import {
    Label,
} from "@progress/kendo-react-labels";
import {
    TextBox,
    InputPrefix,
} from "@progress/kendo-react-inputs";
import {
    Button,
} from '@progress/kendo-react-buttons';
import { SvgIcon } from "@progress/kendo-react-common";
import { NumberIcon } from '../icons/Icons';
import { IconsContext } from '@progress/kendo-react-common';
import { isNullOrEmpty, isObjectNull } from '../../helpers/ObjectHelpers';
import { IconPicker } from 'components/layout/icons/IconPicker';

export default function TextBoxFieldWrapper({
    title = "",
    value = "",
    icon = "",
    disabled = false,
    readOnly = false,
    onChange,
    onClear,
    prefix = "",
    boldTitle = false,
    className = "",
    isRequired = false
}) {

    const hasOnClear = !isObjectNull(onClear);

    const icons = {
        "number": NumberIcon,
    };
    const localValue = isNullOrEmpty(value) ? "" : value;

    const InputPrefixIcon = () => {
        // todo: swap with IconPicker
        switch (icon) {
            case "number":
                return <SvgIcon icon={NumberIcon} />
            default:
                return null;
        }
    }

    return (
        <FieldWrapper>
            <Label className="k-form-label font-size-md" style={{
                fontWeight: boldTitle ? "700" : "normal"
            }}>
                {parse(title) }:
                {isRequired && <span style={{ color: "var(--warning-bg)", marginLeft: "0.25em" }}>*</span>}
            </Label>
            <div className={`k-form-field-wrap ${styles.container}`}>
                <IconsContext.Provider
                    value={{
                        type: 'svg',
                        icons: icons,
                    }}
                >
                    <TextBox
                        value={localValue}
                        disabled={disabled}
                        readOnly={readOnly}
                        onChange={handleOnChange}
                        className={`font-size-lg ${className} ${hasOnClear ? styles.textbox : ''}`}
                        prefix={() => (
                            <>
                                <InputPrefix>
                                    {!isNullOrEmpty(icon) && <InputPrefixIcon />}
                                    {!isNullOrEmpty(prefix) && prefix}
                                </InputPrefix>
                            </>
                        )}
                    />
                    {
                        hasOnClear &&
                            <Button className={styles.button} onClick={onClear}>
                                <IconPicker icon="trash" size={28}/>
                            </Button>
                    }
                </IconsContext.Provider>
            </div>
        </FieldWrapper>
    );

    function handleOnChange(e) {
        if (isObjectNull(onChange)) return;
        onChange(e);
    }
}
